import { Link } from "react-router-dom";
import Router from "../../../const/router";
// Assets
import Logo from "../../../assets/logo.svg";
import "./index.scss";

const Aside = () => {
  return (
    <div className="aside">
      <Link to={Router.HOME} className="aside-logo">
        <img src={Logo} alt="logo" />
      </Link>
      <ul>
        <Link to={Router.ADMIN_SERVICES}>Services</Link>
        <Link to={Router.ADMIN_WORKS}>Works</Link>
        <Link to={Router.ADMIN_SKILLS}>Skills</Link>
        <Link to="">Blog</Link>
      </ul>
      <div className="logout"></div>
    </div>
  );
};

export default Aside;
